// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Modal Component */
:host {
  display: block;
  position: fixed;
  visibility: visible;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

:host(:not([visible])) {
  pointer-events: none;
  visibility: hidden;
}

.ids-modal {
  display: block;
  pointer-events: none;
}
.ids-modal[visible] {
  pointer-events: auto;
}
.ids-modal.fullsize {
  height: 100%;
}
.ids-modal.fullsize .ids-modal-container {
  height: 100% !important;
  min-height: 100% !important;
  max-height: 100% !important;
  width: 100% !important;
}
.ids-modal.fullsize .ids-modal-header + .ids-modal-content {
  overflow-y: auto;
}
.ids-modal:not(.scrollable) .has-scrollbar {
  overflow: hidden;
  padding: 0;
}
.ids-modal.scrollable .has-scrollbar {
  overflow: auto;
}
.ids-modal:not(.fullsize)::part(popup) {
  max-height: calc(100% - 32px);
}

.ids-modal-header {
  padding: var(--ids-modal-header-padding);
}

.ids-modal-content {
  padding: var(--ids-modal-content-padding);
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}

.ids-modal-header + .ids-modal-content {
  padding-block-start: 0;
}

.ids-modal-header,
.ids-modal-footer {
  align-items: center;
  display: flex;
}

.ids-modal-footer {
  margin: var(--ids-modal-footer-margin);
  border-top: 1px solid var(--ids-modal-footer-color-border);
}
.ids-modal-footer[hidden] {
  border-top: none;
}

.ids-modal-container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  width: 100%;
  max-height: calc(100vh - 64px);
}

::slotted([slot=buttons]) {
  flex-grow: 1;
  display: flex;
}

.modal-control-close {
  position: absolute;
  top: var(--ids-space-sm);
  inset-inline-end: var(--ids-space-sm);
}

::slotted([slot=buttons]:not(:first-of-type)) {
  border-inline-start: 1px solid var(--ids-modal-footer-color-border);
}

.ids-modal-button:not(.ids-modal-icon-button):not(:first-of-type) {
  border-left: 1px solid var(--ids-modal-footer-color-border);
}

@media screen and (min-width: 767px) {
  ::slotted([slot=title]) {
    font-size: var(--ids-font-size-lg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ids-modal/ids-modal.scss"],"names":[],"mappings":"AAAA,wBAAA;AAGA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;AADF;;AAIA;EACE,oBAAA;EACA,kBAAA;AADF;;AAIA;EACE,cAAA;EACA,oBAAA;AADF;AAGE;EACE,oBAAA;AADJ;AAIE;EACE,YAAA;AAFJ;AAII;EAEE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,sBAAA;AAHN;AAMI;EACE,gBAAA;AAJN;AASI;EACE,gBAAA;EACA,UAAA;AAPN;AAYI;EACE,cAAA;AAVN;AAeE;EACE,6BAAA;AAbJ;;AAiBA;EACE,wCAAA;AAdF;;AAiBA;EACE,yCAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,sBAAA;AAdF;;AAiBA;;EAEE,mBAAA;EACA,aAAA;AAdF;;AAiBA;EACE,sCAAA;EACA,0DAAA;AAdF;AAgBE;EACE,gBAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;AAfF;;AAkBA;EACE,YAAA;EACA,aAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,wBAAA;EACA,qCAAA;AAfF;;AAsBA;EACE,mEAAA;AAnBF;;AAsBA;EACE,2DAAA;AAnBF;;AAuBA;EACE;IACE,kCAAA;EApBF;AACF","sourcesContent":["/* Ids Modal Component */\n@use '../../themes/mixins/ids-core-mixins' as *;\n\n:host {\n  display: block;\n  position: fixed;\n  visibility: visible;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n}\n\n:host(:not([visible])) {\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.ids-modal {\n  display: block;\n  pointer-events: none;\n\n  &[visible] {\n    pointer-events: auto;\n  }\n\n  &.fullsize {\n    height: 100%;\n\n    .ids-modal-container {\n      // important is needed to override the inline setting styles\n      height: 100% !important;\n      min-height: 100% !important;\n      max-height: 100% !important;\n      width: 100% !important;\n    }\n\n    .ids-modal-header + .ids-modal-content {\n      overflow-y: auto;\n    }\n  }\n\n  &:not(.scrollable) {\n    .has-scrollbar {\n      overflow: hidden;\n      padding: 0;\n    }\n  }\n\n  &.scrollable {\n    .has-scrollbar {\n      overflow: auto;\n    }\n  }\n\n  // Adding top/bottom space to the modal if full height\n  &:not(.fullsize)::part(popup) {\n    max-height: calc(100% - 32px);\n  }\n}\n\n.ids-modal-header {\n  padding: var(--ids-modal-header-padding);\n}\n\n.ids-modal-content {\n  padding: var(--ids-modal-content-padding);\n  flex-grow: 1;\n  flex-shrink: 1;\n  overflow-y: auto;\n}\n\n.ids-modal-header + .ids-modal-content {\n  padding-block-start: 0;\n}\n\n.ids-modal-header,\n.ids-modal-footer {\n  align-items: center;\n  display: flex;\n}\n\n.ids-modal-footer {\n  margin: var(--ids-modal-footer-margin);\n  border-top: 1px solid var(--ids-modal-footer-color-border);\n\n  &[hidden] {\n    border-top: none;\n  }\n}\n\n.ids-modal-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  height: 100%;\n  width: 100%;\n  max-height: calc(100vh - 64px);\n}\n\n::slotted([slot='buttons']) {\n  flex-grow: 1;\n  display: flex;\n}\n\n.modal-control-close {\n  position: absolute;\n  top: var(--ids-space-sm);\n  inset-inline-end: var(--ids-space-sm);\n}\n\n// =====================================================\n// Alter the rules in this block to affect the border\n// between buttons inside the Modal Footer\n\n::slotted([slot='buttons']:not(:first-of-type)) {\n  border-inline-start: 1px solid var(--ids-modal-footer-color-border);\n}\n\n.ids-modal-button:not(.ids-modal-icon-button):not(:first-of-type) {\n  border-left: 1px solid var(--ids-modal-footer-color-border);\n}\n\n// Media queries setup\n@media screen and (min-width: $breakpoint-sm) {\n  ::slotted([slot='title']) {\n    font-size: var(--ids-font-size-lg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
